export enum BillingStatusCodes {
    Active = 'ACT',
    Billed = 'BIL',
    Closed = 'CLS',
    Completed = 'COM',
    NonBillable = 'NOB',
    PartiallyBilled = 'PAB'
}
